import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea5332c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-detail p-4" }
const _hoisted_2 = { class: "grid grid-cols-12" }
const _hoisted_3 = {
  key: 0,
  class: "col-span-12 md:col-span-6 p-2"
}
const _hoisted_4 = { class: "text-2xl" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { class: "flex w-1/2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, "Add More Channels to Team", -1))
const _hoisted_9 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_11 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "mt-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warn w-1/2" }, [
  /*#__PURE__*/_createElementVNode("ol", { class: "notes" }, [
    /*#__PURE__*/_createElementVNode("li", null, " MoodConnect only analyses messages from channels that you add. We do not analyse any other messages. "),
    /*#__PURE__*/_createElementVNode("li", null, " Moodconnect only analyses messages from the time you added the channel. We do not have access to any messages before that. ")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-5 inline" }, "To add channels", -1))
const _hoisted_16 = {
  key: 1,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl p-2" }, "Channels")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_litepie_datepicker = _resolveComponent("litepie-datepicker")!
  const _component_AppPicker = _resolveComponent("AppPicker")!
  const _component_MSTeamsChannels = _resolveComponent("MSTeamsChannels")!
  const _component_SlackChannels = _resolveComponent("SlackChannels")!
  const _component_DiscordChannels = _resolveComponent("DiscordChannels")!
  const _component_ScoreCard = _resolveComponent("ScoreCard")!
  const _component_TeamChannelList = _resolveComponent("TeamChannelList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.teamData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.teamData.team.name), 1),
            (_ctx.teamData.stats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.teamData.stats.channelCount) + " channels", 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.teamData.stats.messageCount) + " scored messages", 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_litepie_datepicker, {
                      placeholder: "Select date range",
                      formatter: { date: 'YYYY-MM-DD', month: 'MMM' },
                      modelValue: _ctx.dateValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateValue) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasConnectedApps())
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_AppPicker, {
                    apps: _ctx.connectedAppsList(),
                    onAppChanged: _ctx.handleAppChange
                  }, null, 8, ["apps", "onAppChanged"]),
                  _createElementVNode("div", null, [
                    (_ctx.company?.teamsConnected)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_ctx.teamData)
                            ? (_openBlock(), _createBlock(_component_MSTeamsChannels, {
                                key: 0,
                                teamId: _ctx.teamData.team.id,
                                onChannelAdded: _ctx.channelListChanged
                              }, null, 8, ["teamId", "onChannelAdded"]))
                            : _createCommentVNode("", true)
                        ], 512)), [
                          [_vShow, _ctx.selectedAppValue == 'ms-teams']
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.company?.slackConnected)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.teamData)
                            ? (_openBlock(), _createBlock(_component_SlackChannels, {
                                key: 0,
                                teamId: _ctx.teamData.team.id,
                                onChannelAdded: _ctx.channelListChanged
                              }, null, 8, ["teamId", "onChannelAdded"]))
                            : _createCommentVNode("", true)
                        ], 512)), [
                          [_vShow, _ctx.selectedAppValue == 'slack']
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.company?.discordConnected)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_ctx.teamData)
                            ? (_openBlock(), _createBlock(_component_DiscordChannels, {
                                key: 0,
                                teamId: _ctx.teamData.team.id,
                                onChannelAdded: _ctx.channelListChanged
                              }, null, 8, ["teamId", "onChannelAdded"]))
                            : _createCommentVNode("", true)
                        ], 512)), [
                          [_vShow, _ctx.selectedAppValue == 'discord']
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createElementVNode("button", {
                      class: "neon-shadow text-blue-500 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({
                            name: 'settings', params: {
                                scrollTo: 'apps'
                            }
                        })))
                    }, "Connect Apps ")
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.teamData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_ScoreCard, {
              emotionScore: _ctx.teamData.scores,
              team: _ctx.teamData.team,
              hideTitle: true
            }, null, 8, ["emotionScore", "team"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_17,
    (_ctx.teamData)
      ? (_openBlock(), _createBlock(_component_TeamChannelList, {
          key: 0,
          team: _ctx.teamData.team,
          startDate: _ctx.startDate,
          endDate: _ctx.endDate,
          onChannelDeleted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.channelDeleted())),
          teamsListHasChanged: _ctx.listChangeKey,
          ref: "teamChannelList"
        }, null, 8, ["team", "startDate", "endDate", "teamsListHasChanged"]))
      : _createCommentVNode("", true)
  ]))
}